import { render, staticRenderFns } from "./DispensaAvisoCertificadoDigial.vue?vue&type=template&id=296d04eb&"
import script from "./DispensaAvisoCertificadoDigial.vue?vue&type=script&lang=js&"
export * from "./DispensaAvisoCertificadoDigial.vue?vue&type=script&lang=js&"
import style0 from "./DispensaAvisoCertificadoDigial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports